<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.75" y="0.75" width="38.5" height="38.5" rx="5.25" stroke="currentColor" opacity="0.7" stroke-width="1.5"/>
<circle cx="12" cy="12" r="4" fill="currentColor"/>
<circle cx="28" cy="12" r="4" fill="currentColor" opacity="0.7"/>
<circle cx="12" cy="28" r="4" fill="currentColor" opacity="0.7"/>
<circle cx="28" cy="28" r="4" fill="currentColor" opacity="0.7"/>
</svg>
